module.exports = __webpack_public_path__ + "static/media/bg1010.86a9fa9e.jpg";